/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Instagram_Review_Collage_AltInputs */

const es_landing_instagram_review_collage_alt = /** @type {(inputs: Landing_Instagram_Review_Collage_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación de Instagram de unrinconatipico destacando Zarpar como plan recomendado`)
};

const gl_landing_instagram_review_collage_alt = /** @type {(inputs: Landing_Instagram_Review_Collage_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación de Instagram de unrinconatipico destacando Zarpar como plan recomendado`)
};

const en_landing_instagram_review_collage_alt = /** @type {(inputs: Landing_Instagram_Review_Collage_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram post by unrinconatipico featuring Zarpar as a recommended plan`)
};

/**
* | output |
* | --- |
* | "Instagram post by unrinconatipico featuring Zarpar as a recommended plan" |
*
* @param {Landing_Instagram_Review_Collage_AltInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_instagram_review_collage_alt = /** @type {((inputs?: Landing_Instagram_Review_Collage_AltInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Instagram_Review_Collage_AltInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_instagram_review_collage_alt(inputs)
	if (locale === "en") return en_landing_instagram_review_collage_alt(inputs)
	return es_landing_instagram_review_collage_alt(inputs)
});